import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(public toastController: ToastController) { }

  async presentToast(message: string, duration: number, cssClass?: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      cssClass: cssClass || 'center-text',
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });
    toast.present();
    const { role } = await toast.onDidDismiss();
  }

  async presentToastWithOptions(header: string, message: string, position: any) {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      position: position,
    });
    await toast.present();
    const { role } = await toast.onDidDismiss();
  }

  dismiss() {
    this.toastController.dismiss();
  }
}
